<template>
  <div>
    <router-view />
  </div>
</template>

<script>
import Home2026 from './home/home2026'
export default {
  name: 'Index',
  components: { Home2026 },
  data() {
    return {
      activeTab: 'home2026'
    }
  },
  created() {
    // window.addEventListener("setItem", res => {
    //   console.log(res, "监听");
    //   if(res.newValue === '5'){
    //     this.visibleName='距离考核结束还有5分钟，请尽快完成考题，避免影响最终成绩。'
    //   }else{
    //     this.visibleName='考试时间已结束，点击"确认获得成绩"。'
    //   }
    //   this.visible = true
    // });
  },
  methods: {}
}
</script>

<style lang="less" scoped>
</style>
